import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-drop-fill text-2xl text-primary-500"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-foreground-900">
                  喷水系统专业方案
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                专注喷水系统领域，提供农业灌溉、景观喷水、工业冷却等全方位喷水解决方案。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                <a href="#quick-links" className="no-underline">快速链接</a>
              </h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">设备分类</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                <a href="#categories" className="no-underline">设备分类</a>
              </h4>
              <ul className="space-y-2">
                <li><Link to="/category?tab=agricultural" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">农业喷水灌溉</Link></li>
                <li><Link to="/category?tab=landscape" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">景观喷水装置</Link></li>
                <li><Link to="/category?tab=industrial" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">工业喷水冷却</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                <a href="#contact-info" className="no-underline">联系方式</a>
              </h4>
              <ul className="space-y-2 text-sm text-foreground-600">
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line text-xs"></i>
                  </div>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-xs"></i>
                  </div>
                  <span>info@penshuixitong.cn</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xs"></i>
                  </div>
                  <span>北京市海淀区中关村科技园</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 喷水系统专业方案. 保留所有权利.
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}